import { Component, Input } from '@angular/core';
import { GroupUI } from '@src/models';
import { ObjectId } from '@src/types/id';

import { ItemType } from '../model/item.model';

@Component({
  selector: 'app-list-item-channels',
  templateUrl: './list-item-channels.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-channels.component.scss'],
})
export class ListItemChannelsComponent {
  @Input() set item(data: ItemType | undefined) {
    this.data = data as GroupUI;
  }

  @Input() selectedId: ObjectId;
  @Input() loading?: boolean;

  data?: GroupUI;
}
